import { getMaxWarmth } from '../utils/warmth';
import type { Settlement } from '../types';

export function getColdestWarmthRatio(settlement: Settlement): number {
    if (settlement.people.length === 0) return 0;
    const maxWarmth = getMaxWarmth();
    if (maxWarmth <= 0) return 0;
    const coldest = settlement.people.reduce(
        (min, person) => Math.min(min, person.warmth),
        maxWarmth,
    );
    return Math.max(0, Math.min(1, (maxWarmth - coldest) / maxWarmth));
}

export function getColdestWarmth(settlement: Settlement): number {
    if (settlement.people.length === 0) return getMaxWarmth();
    return settlement.people.reduce((min, person) => Math.min(min, person.warmth), getMaxWarmth());
}
